import { useEffect, useState } from "react";
import { IconX } from "@tabler/icons-react";
import { useLanguage } from "../../../context/LanguageContext";

interface EditRowNameModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { name: string }) => void;
  isPending?: boolean;
  currentName?: string;
}

export default function EditRowNameModal({
  open,
  onClose,
  onSubmit,
  isPending = false,
  currentName = "",
}: EditRowNameModalProps) {
  const [rowName, setRowName] = useState(currentName);
  const { t } = useLanguage();

  useEffect(() => {
    if (open) {
      setRowName(currentName);
    }
  }, [open, currentName]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (rowName.trim()) {
      onSubmit({ name: rowName.trim() });
    }
  };

  if (!open) return null;

  return (
    // <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div className="bg-[#F7F6F2] rounded-3xl  overflow-hidden shadow-sm flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-4 border-b bg-white">
        <div>
          <h2 className="text-lg font-bold text-[#212121]">{t("Edit Row Name")}</h2>
          <p className="text-xs text-gray-500">{t("Update the name of this row")}</p>
        </div>
        <button
          onClick={onClose}
          className="p-2 hover:bg-gray-100 rounded-full transition"
        >
          <IconX size={20} />
        </button>
      </div>

      {/* Body */}
      <form onSubmit={handleSubmit} className="p-6 space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-semibold text-gray-700">
            {t("Row Name")}
          </label>
          <input
            type="text"
            value={rowName}
            onChange={(e) => setRowName(e.target.value)}
            placeholder={t("Enter row name")}
            className="w-full rounded-xl py-2.5 px-4 border border-gray-300 focus:ring-2 focus:ring-yellow-400 outline-none bg-white transition-all"
            maxLength={3}
            disabled={isPending}
          />
          <p className="text-xs text-gray-500">{t("Maximum 3 characters")}</p>
        </div>
      </form>

      {/* Footer */}
      <div className="flex justify-end gap-3 p-6 border-t bg-white">
        <button
          type="button"
          onClick={onClose}
          disabled={isPending}
          className="px-4 py-2 rounded-full border border-gray-300 bg-white text-gray-700 font-medium hover:bg-gray-100 transition disabled:opacity-50"
        >
          {t("Cancel")}
        </button>
        <button
          type="submit"
          onClick={handleSubmit}
          disabled={isPending || !rowName.trim()}
          className="px-4 py-2 rounded-full bg-[#FBD037] text-black font-medium hover:bg-yellow-500 transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isPending ? t("Updating...") : t("Update")}
        </button>
      </div>
    </div>
    // </div>
  );
}
